<template>
  <div id="commitDraftBills" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="commitDraftBillsLabel">Commit Draft Bills</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeCommitDraftBills"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body d-flex flex-column">
          <div class="mx-auto">
            <div
            v-for="(billingGroup, index) in billingGroupsOptions"
            :key="index"
            class="mb-1 d-flex justify-content-between"
            >
            <div>
              <label class="checkbox">
                <input
                v-model="selectedBillingGroups"
                :value="billingGroup.value"
                type="checkbox"
                />
                <span class="default"></span>
              </label>
              <span class="mx-2" >{{ billingGroup.name }}</span> 
            </div>
            </div>
          </div>

          <div class="col-12">
            <div class="d-flex mt-4">
              <button type="submit" class="btn btn-hc ml-auto mr-3" @click="submit()" :disabled="submitStatus == 'PENDING' || !selectedBillingGroups.length">Submit</button>
              <button type="submit" class="btn btn-hc mr-auto" data-dismiss="modal" aria-label="Close">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
	data() {
		const supplierId = Vue.config.honeycomb.supplierId;
		let defaultBillingGroups;
		if (['DUAL', 'SEBL'].includes(supplierId)) {
			defaultBillingGroups = ['Monthly', 'Electricity'];
		} else {
			defaultBillingGroups = ['KeyAccounts', 'NonKeyAccounts'];
		}
		return {
			submitStatus: null,
			selectedBillingGroups: defaultBillingGroups,
		};
	},

	computed: {
		billingGroups() {
			return Vue.config.honeycomb.billingGroups;
		},

		billingGroupsOptions() {
			return this.billingGroups;
		},

		upsert() {
			return {
				ProcessEverything: true,
			};
		},
	},

	methods: {
		async submit() {
			let requests = [];

			this.selectedBillingGroups.forEach((type) => {
				requests.push(this.send(type));
			});

			const res = await Promise.allSettled(requests);

			if (res.some((r) => r.status === 'rejected')) this.submitStatus = 'ERROR';
			else this.submitStatus = 'OK';

			document.getElementById('closeCommitDraftBills').click();
		},

		send(type) {
			this.submitStatus = 'PENDING';

			this.$http
				.put(
					`https://${
						Vue.config.honeycomb.billbotbillrun.domain
					}/api/v1/billruns/billinggroupcommit/${type}`,
					this.upsert,
					{ withCredentials: true }
				)
				.then(() => {
					if (type === 'Monthly')
						this.$snotify.success(`Success! Gas Draft bills committed.`);
					else this.$snotify.success(`Success! ${type} Draft bills committed.`);
				})
				.catch((error) => {
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						if (error.response.data.MoreInformation.length > 0) {
							error.response.data.MoreInformation.forEach((e) => {
								this.$snotify.error(`${e.Error}`, {
									timeout: 0,
									closeOnClick: true,
								});
							});
						} else {
							this.$snotify.error(`${error.response.data.UserDescription}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						this.$snotify.error(`No response recieved.`, {
							timeout: 0,
							closeOnClick: true,
						});
					} else {
						// Something happened in setting up the request that triggered an Error
						this.$snotify.error(`${error.message}`, {
							timeout: 0,
							closeOnClick: true,
						});
					}
				});
		},
	},
};
</script>
